var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 0.554,
    d: "M4.496 11.357h3.052m-3.052 0H1.68c-1.357 0-1.503-1.941.249-2.16.182-.022.332-.168.332-.351v-2.42C2.26 4.78 3.3 3.1 4.983 2.616m-.487 8.741S4.535 13 5.993 13s1.555-1.643 1.555-1.643m0 0h2.773c1.357 0 1.504-1.941-.248-2.16-.183-.022-.333-.168-.333-.351v-2.42c0-1.66-1.088-3.354-2.807-3.821m0 0q-.45-.124-.955-.126-.528.002-.995.137m1.95-.011S7.373 1 5.978 1s-.995 1.616-.995 1.616"
  })));
};
export default SvgBell;